import { Attributes } from './types';

// We map this to our own internal plugins/richtext.ts formatting
export const TEXT_TAGS: {
  [key: string]: Attributes | undefined;
} = {
  DEL: { s: true },
  EM: { i: true },
  I: { i: true },
  S: { s: true },
  B: { b: true },
  STRONG: { b: true },
  U: { u: true },
};

export const ELEMENT_TAGS: {
  [key: string]: (element: Element) => {
    type: string;
    url?: string | null;
  };
} = {
  A: (el: Element) => ({
    type: 'inlineLink',
    url: el.getAttribute('href'),
  }),
  BLOCKQUOTE: () => ({ type: 'blockquote' }),
  H1: () => ({ type: 'h1' }),
  H2: () => ({ type: 'h2' }),
  H3: () => ({ type: 'h3' }),
  LI: () => ({ type: 'list-item' }),
  OL: () => ({ type: 'ordered-list' }),
  P: () => ({ type: 'p' }),
  UL: () => ({ type: 'unordered-list' }),
};
